/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Artic
 * The Artic API documentation
 * OpenAPI spec version: 1.0
 */
import {
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  AuditControllerListParams,
  AuditPageDto
} from '../schemas';

import { customFetch } from '../../custom-fetch.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type auditControllerListResponse200 = {
  data: AuditPageDto
  status: 200
}

export type auditControllerListResponse401 = {
  data: void
  status: 401
}

export type auditControllerListResponse403 = {
  data: void
  status: 403
}

export type auditControllerListResponseSuccess = (auditControllerListResponse200) & {
  headers: Headers;
};
export type auditControllerListResponseError = (auditControllerListResponse401 | auditControllerListResponse403) & {
  headers: Headers;
};

export type auditControllerListResponse = (auditControllerListResponseSuccess | auditControllerListResponseError)

export const getAuditControllerListUrl = (params: AuditControllerListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/audit?${stringifiedParams}` : `/audit`
}

/**
 * Returns audit events for the given partner (plus global admin events) ordered newest first, paginated via limit/offset. Requires membership of the partner (or admin).
 * @summary List audit events for a partner
 */
export const auditControllerList = async (params: AuditControllerListParams, options?: Parameters<typeof customFetch>[1]): Promise<auditControllerListResponse> => {

  return customFetch<auditControllerListResponse>(getAuditControllerListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAuditControllerListQueryKey = (params?: AuditControllerListParams,) => {
    return [
    `/audit`, ...(params ? [params] : [])
    ] as const;
    }


export const getAuditControllerListQueryOptions = <TData = Awaited<ReturnType<typeof auditControllerList>>, TError = void>(params: AuditControllerListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditControllerList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuditControllerListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof auditControllerList>>> = ({ signal }) => auditControllerList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof auditControllerList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuditControllerListQueryResult = NonNullable<Awaited<ReturnType<typeof auditControllerList>>>
export type AuditControllerListQueryError = void


export function useAuditControllerList<TData = Awaited<ReturnType<typeof auditControllerList>>, TError = void>(
 params: AuditControllerListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditControllerList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof auditControllerList>>,
          TError,
          Awaited<ReturnType<typeof auditControllerList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuditControllerList<TData = Awaited<ReturnType<typeof auditControllerList>>, TError = void>(
 params: AuditControllerListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditControllerList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof auditControllerList>>,
          TError,
          Awaited<ReturnType<typeof auditControllerList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuditControllerList<TData = Awaited<ReturnType<typeof auditControllerList>>, TError = void>(
 params: AuditControllerListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditControllerList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List audit events for a partner
 */

export function useAuditControllerList<TData = Awaited<ReturnType<typeof auditControllerList>>, TError = void>(
 params: AuditControllerListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditControllerList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuditControllerListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List audit events for a partner
 */
export const prefetchAuditControllerListQuery = async <TData = Awaited<ReturnType<typeof auditControllerList>>, TError = void>(
 queryClient: QueryClient, params: AuditControllerListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditControllerList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getAuditControllerListQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getAuditControllerListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof auditControllerList>>, TError = void>(params: AuditControllerListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof auditControllerList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuditControllerListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof auditControllerList>>> = ({ signal }) => auditControllerList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof auditControllerList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuditControllerListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof auditControllerList>>>
export type AuditControllerListSuspenseQueryError = void


export function useAuditControllerListSuspense<TData = Awaited<ReturnType<typeof auditControllerList>>, TError = void>(
 params: AuditControllerListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof auditControllerList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuditControllerListSuspense<TData = Awaited<ReturnType<typeof auditControllerList>>, TError = void>(
 params: AuditControllerListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof auditControllerList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuditControllerListSuspense<TData = Awaited<ReturnType<typeof auditControllerList>>, TError = void>(
 params: AuditControllerListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof auditControllerList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List audit events for a partner
 */

export function useAuditControllerListSuspense<TData = Awaited<ReturnType<typeof auditControllerList>>, TError = void>(
 params: AuditControllerListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof auditControllerList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuditControllerListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






